import classNames from 'classnames'
import React from 'react'
import { resolveInitialSearchQuery } from '../../reducers/user'
import { MaxWidthNameColumn } from '../../util/table'
import { StateIndicator } from '../badge/SmallBadge'
import { PreservingLink } from '../ui/PreservingLink'
import { NameText } from './NameText'

interface AdGroupBreadcrumbsComponentProps {
    campaign?: {
        campaign_id?: number | string
    }
    campaign_id?: number | string
    campaign_name?: string
    className?: string
    stateMessage?: React.ReactNode
    parent_campaign_status?: string | number
    fill?: boolean
    screenshotMode?: boolean
}

export class AdGroupBreadcrumbsComponent extends React.PureComponent<AdGroupBreadcrumbsComponentProps> {
    render() {
        const searchQuery = resolveInitialSearchQuery()
        const campaign = this.props.campaign
        const campaign_id = this.props.campaign_id
        const campaignName = this.props.campaign_name
        const className = this.props.className
        const stateMessage = this.props.stateMessage
        const campaignStatus = this.props.parent_campaign_status
        const fill = this.props.fill
        const screenshotMode = this.props.screenshotMode

        const campaignId = campaign_id ?? campaign?.campaign_id

        let toCampaign = `/campaigns/${campaignId}`
        if (searchQuery) {
            toCampaign = `${toCampaign}?${searchQuery}`
        }

        return (
            <div
                className={classNames(className, fill && 'min-w-0 w-full overflow-hidden')}
                style={{ lineHeight: '21px' }}
            >
                {stateMessage && <div>{stateMessage}</div>}
                {campaignId && (
                    <div
                        className={classNames(
                            'flex min-w-0 items-center overflow-hidden',
                            fill && 'w-full',
                        )}
                        style={{ maxWidth: fill ? undefined : MaxWidthNameColumn }}
                    >
                        {/* The inner span cuts the text, so Blueprint sees no overflow and sets no title. */}
                        <NameText
                            screenshotMode={screenshotMode}
                            title={campaignName}
                            className="relative block min-w-0 w-full overflow-hidden"
                        >
                            <PreservingLink
                                className={classNames(
                                    'relative min-w-0 overflow-hidden',
                                    fill && 'inline-flex w-full',
                                    { blur: screenshotMode },
                                )}
                                to={toCampaign}
                                style={{ maxWidth: fill ? undefined : MaxWidthNameColumn }}
                            >
                                <StateIndicator value={campaignStatus} top={6} left={0} />
                                <span className="block min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap pl-2.5">
                                    {campaignName}
                                </span>
                            </PreservingLink>
                        </NameText>
                    </div>
                )}
            </div>
        )
    }
}
